export type CaptureVideoFrameOpts = {
  /** true면 픽셀도 180도 회전(표시 rotate_180과 증거 스냅샷 일치) */
  rotate180?: boolean;
};

/** 관제 CCTV video 요소에서 현재 프레임 JPEG data URL 캡처 (실패 시 undefined) */
export function captureVideoFrame(
  video: HTMLVideoElement | null | undefined,
  opts?: CaptureVideoFrameOpts
): string | undefined {
  if (!video) return undefined;
  const w = video.videoWidth;
  const h = video.videoHeight;
  // WebRTC(srcObject)는 readyState가 낮아도 프레임이 있을 수 있음
  const hasStream = Boolean(video.srcObject);
  if (!hasStream && video.readyState < 2) return undefined;
  if (!w || !h) return undefined;
  try {
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) return undefined;
    if (opts?.rotate180) {
      ctx.translate(w, h);
      ctx.rotate(Math.PI);
    }
    ctx.drawImage(video, 0, 0, w, h);
    return canvas.toDataURL('image/jpeg', 0.82);
  } catch {
    // cross-origin tainted 등 — WebRTC MediaStream은 보통 성공
    return undefined;
  }
}

/** API 업로드용 — data URL 접두사 없이 base64만 반환 */
export function captureVideoFrameBase64(
  video: HTMLVideoElement | null | undefined,
  opts?: CaptureVideoFrameOpts
): string | undefined {
  const dataUrl = captureVideoFrame(video, opts);
  if (!dataUrl) return undefined;
  const comma = dataUrl.indexOf(',');
  return comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
}
